import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Formik } from 'formik';
import { Modal, Panel } from '@kajabi/sage-react';

import { useUiResourceContext, useConfigContext } from 'common/components/CopyMagic/contexts';
import Loader from 'common/components/CopyMagic/components/Loader';
import ErrorMessage from 'common/components/CopyMagic/components/ErrorMessage';
import CloseButton from 'common/components/CopyMagic/components/CloseButton';
import { promptSchema } from 'common/components/CopyMagic/shared/validationSchema';
import useSubmitPromptSetResult from 'common/components/CopyMagic/hooks/useSubmitPromptSetResult';
import PromptForm from 'common/components/CopyMagic/components/PromptForm';

import ResultDisplay from './components/ResultDisplay';
import FooterActions from './components/FooterActions';
import './style.scss';

const ContentAssistant = () => {
  const { open } = useUiResourceContext();
  const { initialValues, submitPrompt } = useSubmitPromptSetResult();
  const { scopedClassName, generatorName } = useConfigContext();

  if (!open) return null;

  const className = [
    'copy-magic-modal',
    `copy-magic-modal--generator-name-${generatorName.toLowerCase()}`,
    scopedClassName,
  ].join(' ');

  return ReactDOM.createPortal(
    <Modal size={Modal.SIZES.MD} active allowScroll className={className}>
      <Modal.Header title="✨ Content assistant" aside={<CloseButton />}></Modal.Header>
      <Formik
        initialValues={initialValues}
        onSubmit={submitPrompt}
        validationSchema={promptSchema}
        validateOnMount
      >
        <Form>
          <Modal.Body>
            <PromptForm labelText="Prompt" />
            <Panel.Divider bleed />
            <Loader />
            <ErrorMessage />
            <ResultDisplay />
          </Modal.Body>
          <FooterActions />
        </Form>
      </Formik>
    </Modal>,
    document.body,
  );
};

export default ContentAssistant;
